import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { ApiService } from '../services/contratos/contratos.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ContratoTransportadoraFormDialogComponent } from '../app/home/contrato_transportadora/contrato-transportadora-form-dialog.component';
import { Observable, Subscription, interval, map, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { format } from 'date-fns';
import { ContratoTerrestreFormDialogComponent } from '../app/home/contrato_terrestre/contrato-terrestre-form-dialog.component';
import { ExtraRequestComponent } from '../app/home/extra-request/extra-request.component';
import { UsuarioLogado } from '../autenticacao/usuario-logado.type';
import { AutenticacaoService } from '../autenticacao/autenticacao.service';
import { AppModule } from '../app.module';
import { Validators } from '@angular/forms';
import * as XLSX from 'xlsx';
import * as fs from 'file-saver'; // Importe a biblioteca file-saver
import * as ExcelJS from 'exceljs';
import { readFile } from 'xlsx';
import { MatRadioModule } from '@angular/material/radio';
import { AnyLayout } from 'mapbox-gl';


@Component({
    selector: 'app-novo-fornecedor-frete-extra',
    templateUrl: './novo-fornecedor-frete-extra.component.html',
    styleUrls: ['./novo-fornecedor-frete-extra.component.css'],
    standalone: false
})
export class NovoFornecedorFreteExtraComponent {


  item: any = {};
  items: any[] = [];
  filtereditems: any[] = [];
  usuarios: any[] = [];
  carriers: any[] = [];
  urlAtualiza: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  urlNotify: string = 'https://29o5gcw81i.execute-api.sa-east-1.amazonaws.com/v1';
  urlConsultaTrips: string = 'https://qu0d5gqb4g.execute-api.sa-east-1.amazonaws.com/v1/';
  query: string = 'TransportadoresFreteExtra';
  queryUsers: string = 'usersPortal';
  queryCarriers: string = 'Carriers';
  querylocation: string = 'Fornecedores_Karrara_Transport';
  comentario: string = "";
  $even: any;
  $odd: any;
  dataSource: any;
  itemsCarrier: any[] = [];
  itemsCompletos: any[] = [];
  searchString: string = '';
  itemsOrigin: any[] | undefined;
  placesOrigin: any[] | undefined;
  usuarioLogado!: UsuarioLogado;
  currentDate = new Date();
  existingExcelFile: string = 'C:/Users/ssbuif/Desktop/Transport Instruction-teste.xlsx';
  locais!: any[]

  typesVehicles: string[] = [
    'Picape(fiorino) Aberta 500Kg - C1,60 x L1,00 x A1,20',
    'Picape(fiorino) Fechada - C1,60 x L1,00 x A1,20',
    'Picape(fiorino) Refrigerada - C1,60 x L1,00 x A1,20',
    'Kombi 800kg - C1,60 x L1,00 x A1,20',
    'VAN Furgão 1,5t - C3,20 x L1,80 x A1,80',
    'HR Bongo 1,5t - C2,80 x L1,80 x A1,80',
    'HR Bongo Sider 1,5t - C2,80 x L1,80 x A1,80',
    'HR Bongo Aberto 1,5t - C2,80 x L1,80 x A1,80',
    'HR Bongo Refrigerado 1,5t - C2,80 x L1,80 x A1,80',
    'VUC - 3/4 3t - C4,80 x L2,20 x A2,20',
    'VUC - 3/4 Aberto 3t - C4,80 x L2,20 x A2,20',
    'VUC - 3/4 Sider 3t - C4,80 x L2,20 x A2,20',
    'VUC - 3/4 Refrigerado 3t - C4,80 x L2,20 x A2,20',
    'Toco Aberto 6ton - C6,50 x L2,40 x A2,60',
    'Toco Sider 6ton - C6,50 x L2,40 x A2,60',
    'Toco 6ton Refrigerado - C6,50 x L2,40 x A2,60',
    'Truck Aberto 12ton - C8,50 x L2,40 x A2,70',
    'Truck Sider 12ton - C8,50 x L2,40 x A2,70',
    //'Truck Refrigerado 12ton - C8,50 x L2,40 x A2,70',
    'Carreta 25ton Aberta - C14,80 x L2,50 x A2,70',
    'Carreta 25ton Sider - C14,80 x L2,50 x A2,70',
    //'Carreta 25ton Baú - C14,80 x L2,50 x A2,70',
    'Carreta 27ton Aberta - C14,80 x L2,50 x A2,70',
    'Carreta 27ton Sider - C14,80 x L2,50 x A2,70',
    //'Carreta 27ton Baú - C14,80 x L2,50 x A2,70',
    'Truck Munk',
    'Guincho Prancha'
  ];
  dialogOpen: boolean = false;
  formBuilder: any;
  formGroup: any;
  selectedValue = 0;
  contactCarrier: string = '';
  contactTrasport: string = '+5511974882943';
  status: string = 'Requested';
  dataNotify: any;
  isCarrierEnabled: boolean = false;
  campoTocado: boolean = false;
  fileName = 'ExcelSheet.xlsx';
  isLoading: boolean = true;
  isUserEnabled: boolean = false;
  isAdminEnabled: boolean = false;
  locationDeliveryChanged!: boolean;
  locationPickupChanged!: boolean;
  subscription: Subscription | undefined;
  // endDate: string | number | Date;
  endDate: Date = new Date();
  startDate: Date = new Date();
  endDateIni: Date = new Date();
  startDateIni: Date = new Date();
  startDateFilter!: Date;// Data de início do intervalo selecionado
  endDateFilter!: Date; // Data de término do intervalo selecionado
  dateInicial = new Date('1970-01-02')
  temCaracterEspecial: boolean = false;


  @ViewChild('dateInput') dateInput: any;
  @ViewChild('dateInput2') dateInput2: any;
  allItems: any[] = [];
  contatoColeta!: string;
  telefoneColeta!: string;
  contatoEntrega!: string;
  telefoneEntrega!: string;
  selectVehicle: boolean = false;
  veiculoSelected = {
    ID: "",
    transportadora: "",
    veiculo: [
      {
        km0a50: 0,
        km51a100: 0,
        km101a200: 0,
        km201a500: 0,
        km501a1000: 0,
        km1000: 0,
        modelo: ""
      }]
    }



  constructor(
    public dialog: MatDialog,
    private dynamodbService: ApiService,
    private autenticacaoService: AutenticacaoService,
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
  ) {
  }

  async ngOnInit(): Promise<void> {
    if (!this.item.veiculo) {
      this.item.veiculo = [];
    }
    // console.log(this.dialogOpen )
    await this.getUsers()
    await this.getUserLogado()
    await this.getItemsFromOrigin();
    await this.getCarriers()
    await this.enableFields();
    await this.getItemsFromDynamoDB();
    this.isLoading = false;
    this.subscription = interval(3 * 60 * 1000).subscribe(async () => {
      await this.upDate()
      await this.enableFields();
      this.isLoading = false;    
    });

  }

  async upDate() {
    await this.getItemsFromDynamoDB();
    await this.getItemsFromOrigin();
  }

  onFieldTouched() {
    this.campoTocado = true;
  }

  enableFields() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9') {
      this.isAdminEnabled = true;
    } else if (this.usuarioLogado.role == '1' || this.usuarioLogado.role == '6' || this.usuarioLogado.role == '5' || this.usuarioLogado.role == '7' || this.usuarioLogado.role == '8') {
    // } else if (this.usuarioLogado.role == '1') {
      this.isUserEnabled = true;
    } else if (this.usuarioLogado.role == '3') {
      this.isCarrierEnabled = true;
    }
  }

  editDialog(item: any, index:number): void {
    // console.log(item)
    // console.log(this.veiculoSelected)
    this.campoTocado = false;
    this.enableFields();
    this.item.ID = item.ID;
    this.item.transportadora = item.transportadora;
    this.item.veiculo = item.veiculo;
    // this.item.modelo = item.modelo;
    // this.item.veiculo = this.veiculoSelected.veiculo;
    // console.log(item.veiculo[item.veiculo.length - 1].modelo)
    // item.veiculo[item.veiculo.length - 1].modelo = "-"
    // console.log( item.veiculo)
    this.dialogOpen = true;
  }

  solicitarFrete() {
    this.item = [];
    this.item.ID = format(new Date(), 'ddMMyyyyHHmmss');
    this.dialogOpen = true;
    if (!this.item.veiculo) {
      this.item.veiculo = [];
    }
    //console.log(this.item.date)
  }

  verificarCaracteresEspeciais() {
    // Utiliza uma expressão regular para verificar caracteres especiais
    this.temCaracterEspecial = /[^\w\s]/.test(this.item.description);
  }

  async salvar2(item: any) {
    this.selectVehicle = false;
    // console.log(this.veiculoSelected)

    // console.log(item)
    // console.log(this.item)
    this.isLoading = true;
    try {
      // Verifica se o transportador e pelo menos um veículo estão preenchidos
      if (this.item.transportadora && this.item.veiculo && this.item.veiculo.length > 0) {
        // Mapeia os veículos para o formato desejado
        const veiculos = this.item.veiculo.map((veiculo: any, index: number) => {
          return {
            "km0a50": veiculo.km0a50,
            "km51a100": veiculo.km51a100,
            "km101a200": veiculo.km101a200,
            "km201a500": veiculo.km201a500,
            "km501a1000": veiculo.km501a1000,
            "km1000": veiculo.km1000,
            "modelo": veiculo.modelo
            // Adicione outras propriedades do veículo conforme necessário
          };
        });
  
        // Monta o objeto para ser salvo
        const objetoParaSalvar = {
          "ID": this.item.ID,
          "transportadora": this.item.transportadora,
          "validade": this.item.validade,
          "veiculo": veiculos,
          "tableName":this.query
          // Adicione outras propriedades conforme necessário
        };
  
        // Adicione o objeto à tabela especificada
        objetoParaSalvar.tableName = this.query;  
        // Converte o objeto para uma string JSON
        const objetoString = JSON.stringify(objetoParaSalvar);  
        // Remove barras invertidas escapadas
        const objetoSemEscape = objetoString.replace(/\\"/g, '"');  
        // Converte a string JSON para um objeto JavaScript
        const objetoFinal = JSON.parse(objetoSemEscape);  
        // Chama o serviço para salvar no DynamoDB (ou serviço similar)
        await this.dynamodbService.salvar([objetoFinal], this.query, this.urlAtualiza)
          .subscribe(async response => {
            // console.log(response);
            await this.upDate();
            this.dialogOpen = false;
            this.isLoading = false;
          }, error => {
            console.log(error);
          });
      } else {
        this.campoTocado = true;
        alert("Formulário incompleto!");
        this.isLoading = false;
      }
    } catch (error) {
      const confirmacao = window.confirm("Por favor, revise o preenchimento do formulário!");
      if (confirmacao) {
        this.isLoading = false;
        console.error('Error :', error);
      }
    }
  }

  clearFilter() {
    this.filtereditems = this.itemsCompletos;
    this.dateInput.nativeElement.value = '';
    this.dateInput2.nativeElement.value = '';
    this.startDateFilter = this.dateInicial
    this.endDateFilter = this.dateInicial
    // //console.log(this.startDateFilter)
  }

  formatarComoMoeda(valor: string): string {
    try{
    const valorNumerico = parseFloat(valor.replace(',', '.'));

    if (!isNaN(valorNumerico)) {
      return valorNumerico.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    } else {
      return valor;
    }
  }
    catch{
      return valor;
    }
  }

  async applyFilter() {
    if (this.startDateFilter && this.endDateFilter) {
      this.startDate = new Date(this.startDateFilter); // Certifique-se de que this.startDate seja um valor válido no formato de data
      this.startDate.setHours(0, 0, 0, 0); // Define as horas, minutos, segundos e milissegundos para zero
      this.startDate.setDate(this.startDate.getDate() + 1); // Acrescenta um dia
      // //console.log(this.startDate)
      this.endDate = new Date(this.endDateFilter);
      this.endDate.setHours(0, 0, 0, 0);
      this.endDate.setDate(this.endDate.getDate() + 1); // Acrescenta um dia
      // //console.log(this.endDate)
      this.filtereditems = await this.items.filter(item => {
        const itemDate = new Date(item.date); // Altere a propriedade 'entrada' para o campo que contém a data nos seus dados
        itemDate.setHours(0, 0, 0, 0);
        return itemDate >= this.startDate && itemDate <= this.endDate;
      });
    } else {
      // //console.log("else filtro")
      this.filtereditems = this.items;
      // //console.log(this.items)
      // //console.log(this.filtereditems)
    }
  }

  async aplicarFiltro() {
    if (!this.searchString) {
      if (this.startDateFilter && this.endDateFilter && this.startDateFilter != this.dateInicial && this.endDateFilter != this.dateInicial) {
        this.filtereditems = await this.items.filter(item => {
          const itemDate = new Date(item.date); // Altere a propriedade 'entrada' para o campo que contém a data nos seus dados
          itemDate.setHours(0, 0, 0, 0);
          return itemDate >= this.startDate && itemDate <= this.endDate;
        });
      } else {
        this.filtereditems = this.items;
      }
    }
    this.filtereditems = this.filtereditems.filter(item => this.filtrarItem(item));
  }

  //adicionado filtro para todos os campos
  filtrarItem(item: any): boolean {
    if (!this.searchString) {
      // Se o filtro estiver vazio, retorne verdadeiro para exibir todos os itens
      return true;
    }

    const lowerCaseFilter = this.searchString.toLowerCase();

    // Verificar se alguma propriedade do item corresponde ao filtro (ignorando maiúsculas e minúsculas)
    for (const prop in item) {
      if (item.hasOwnProperty(prop) && typeof item[prop] === 'string') {
        const lowerCaseProp = item[prop].toLowerCase();
        if (lowerCaseProp.includes(lowerCaseFilter)) {
          return true;
        }
      }
    }

    // Se nenhuma propriedade corresponder ao filtro, retornar falso para não exibir o item
    return false;
  } 
 
  async getCarriers(): Promise<void> {
    const filtroUser = '';
    (await this.dynamodbService.getItems(this.queryCarriers, this.urlConsulta, filtroUser)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.carriers = items.map(item => ({ ...item, checked: false }));
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
          // //console.log('this.carriers')
          // //console.log((this.carriers))
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  async getUsers(): Promise<void> {
    const filtroUser = '';
    (await this.dynamodbService.getItems(this.queryUsers, this.urlConsulta, filtroUser)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.usuarios = items.map(item => ({ ...item, checked: false }));
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
          // //console.log('this.usuarios')
          // //console.log((this.usuarios))
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  verificaContato(newValue: string) {
    // //console.log("entrou no verifica")
    // //console.log(newValue)
    this.item.contatoPickup = this.locais.find(item => item.local == newValue).nomeContato
    this.item.telefonePickup = this.locais.find(item => item.local == newValue).telefone
    // //console.log(this.contatoColeta)
  }

  verificaContatoEntrega(newValue: string) {
    // //console.log("entrou no verifica")
    // //console.log(newValue)
    this.item.contatoDelivery = this.locais.find(item => item.local == newValue).nomeContato
    this.item.telefoneDelivery = this.locais.find(item => item.local == newValue).telefone
    // //console.log(this.contatoColeta)
  }

  cancel(): void {
    this.campoTocado = false;
    this.dialogOpen = false;
    this.locationDeliveryChanged = false;
    this.locationPickupChanged = false;
  }

  async getUserLogado() {
    // //console.log("logado")
    // //console.log(this.autenticacaoService?.obterUsuarioLogado())
    this.usuarioLogado = await this.autenticacaoService.obterUsuarioLogado()
    // //console.log(this.usuarioLogado)
  }


  getStatusClass(status: string): string {
    if (status == 'Planned') {
      this.status = 'planned';
      return 'planned';
    } else if (status == 'Executing') {
      return 'executing';
    } else if (status == 'Completed') {
      return 'completed';
    } else if (status == 'Canceled') {
      return 'canceled';
    } else if (status == 'Reject') {
      return 'rejected';
    } else if (status == 'NOVA SOLICITAÇÃO') {
      return 'novaSolicitacao';
    } else {
      return '';
    }
  }

  async getItemsFromOrigin(): Promise<void> {
    const filtro = '';
    (await this.dynamodbService.getItems(this.querylocation, this.urlConsulta, filtro)).subscribe(
      async (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.itemsOrigin = items.map(item => ({ ...item, checked: false }));

              // Ordena os itens em ordem alfabética com base na propriedade 'local'
              await this.itemsOrigin.sort((a, b) => a.local.localeCompare(b.local));

              // Salva os locais ordenados em this.placesOrigin
              this.placesOrigin = this.itemsOrigin.map(item => item.local);
              this.locais = items;
              // //console.log(this.placesOrigin)
              // //console.log(items)                          
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }


  async getItemsFromDynamoDB(): Promise<void> {
    try {
      const lambdaEvent = {
        "tableName": "TransportadoresFreteExtra",
        "searchConditions": [
          // { "column": "status", "word": "Completed", "negate": true },
          // { "column": "status", "word": "Canceled", "negate": true },
          // { "column": "Finalizada", "word": "true", "negate": true },
          // { "column": "Finalizada", "word": "True", "negate": true },
          // { "column": "ID", "word": "", "negate": true }
        ]
      };
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsFiltroColuna(lambdaEvent, this.urlConsultaTrips, 'filtro')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          // //console.log(response.body)
          const items = await JSON.parse(response.body);
          this.allItems = items;
          // console.log(items)
          if (Array.isArray(items)) {
            this.items = items;
            // this.items = items.map(item => ({ ...item, checked: false }));
            // if (this.usuarioLogado.role.toString() == '1') {
            //   // //console.log("entrou role 1")
            //   // //console.log(this.usuarioLogado)
            //   // //console.log(this.items.forEach(id => //console.log(id.reqId)))
            //   if (this.usuarioLogado)
            //     this.items = await items.filter(item => item.reqId.toLowerCase() == this.usuarioLogado.id.toLowerCase())
            // }
            // else if (this.usuarioLogado.role != '9' && this.usuarioLogado.role != '2') {
            //   this.items = await items.filter(item => item.carrier == this.usuarioLogado.company)
            // }

            // this.items = await this.items.filter(item => item.status != 'Canceled' && item.status != 'Completed')

            // this.items.sort((a, b) => {
            //   return b.date.localeCompare(a.date);
            // });

            // //console.log(this.startDateFilter)
            // if (this.startDateFilter && this.endDateFilter && this.startDateFilter != this.dateInicial && this.endDateFilter != this.dateInicial) {
            //   // //console.log("entrou no filtro")
            //   this.filtereditems = await this.items.filter(item => {
            //     const itemDate = new Date(item.date); // Altere a propriedade 'entrada' para o campo que contém a data nos seus dados
            //     itemDate.setHours(0, 0, 0, 0);
            //     return itemDate >= this.startDate && itemDate <= this.endDate;
            //   });
            // } else {
            //   this.filtereditems = this.items;
            // }
            this.itemsCompletos = this.items;
            // console.log(this.items)
            // //console.log(this.itemsCarrier)
            // Adiciona a chave 'checked' a cada item, com valor inicial como false
            // Forçar detecção de alterações após atualizar os dados
            this.cdr.detectChanges();
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error('Error parsing JSON:', error);
    }
  }

  async deleteItem(ID: string, urlDeleta: string, query: string): Promise<void> {
    const confirmacao = window.confirm("Tem certeza que deseja excluir este registro?");

    // Verifica se o usuário confirmou a ação
    if (confirmacao) {
      this.isLoading = true;

      await this.dynamodbService.deleteItem(ID, this.urlAtualiza, this.query).subscribe(
        async response => {
          // setTimeout(() => {
          await this.getItemsFromDynamoDB();
          this.isLoading = false;

          // }, 400); // Ajuste o tempo de atraso conforme necessário
        },
        error => {
          // Lógica para lidar com erros durante a deleção do item
        }
      );
    }
  }

  adicionarDailyCost() {
    // Adiciona um novo campo com scperiod: 0
    this.item.veiculo.push({ km0a50: 0.0, km51a100:0.0, km101a200: 0.0, km201a500: 0.0, km501a1000: 0.0, km1000: 0.0 });
  }

  removerDailyCost(index: number) {
    this.item.veiculo.splice(index, 1);
  }

 


}